import React from "react";
import LegalLayout from "./LegalLayout";

export default function AvisoLegalPage() {
  return (
    <LegalLayout title="Aviso legal" testid="aviso-legal-page">
      <h2>Titular del sitio web</h2>
      <p>
        En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la
        Información y de Comercio Electrónico (LSSI-CE), se informa:
      </p>
      <ul>
        <li>Titular: Santiago Lorenzo Garrido</li>
        <li>NIF: 34986749T</li>
        <li>Domicilio: Calle Méjico 4, 24193 Navatejera (León), España</li>
        <li>
          Email:{" "}
          <a href="mailto:santilorenzogar@gmail.com">santilorenzogar@gmail.com</a>
        </li>
        <li>Teléfono / WhatsApp: +34 605 045 728</li>
        <li>
          Actividad: servicios de mentoría y acompañamiento en desarrollo personal y
          profesional, formación online y conferencias.
        </li>
      </ul>

      <h2>Objeto</h2>
      <p>
        Este sitio web ofrece información sobre los servicios de Santi Lorenzo y el Método
        SIRCS: mentorías grupales, sesiones privadas, formaciones, contenidos gratuitos y
        conferencias.
      </p>

      <h2>Naturaleza de los servicios</h2>
      <p>
        Los servicios ofrecidos son de desarrollo personal y acompañamiento. No constituyen
        tratamiento sanitario, psicológico ni médico, ni sustituyen la atención de un
        profesional sanitario. Si atraviesas un problema de salud mental, consulta con un
        profesional sanitario.
      </p>

      <h2>Condiciones de uso</h2>
      <p>
        El acceso al sitio es gratuito y atribuye la condición de usuario, que se compromete a
        hacer un uso lícito del mismo y de sus contenidos, sin dañar la imagen, los intereses
        o los derechos del titular o de terceros.
      </p>

      <h2>Propiedad intelectual e industrial</h2>
      <p>
        Todos los contenidos de este sitio (textos, imágenes, audios, vídeos, logotipos, la
        marca y el Método SIRCS™, así como su diseño) son propiedad del titular o se usan con
        licencia. Queda prohibida su reproducción, distribución, comunicación pública o
        transformación sin autorización expresa por escrito.
      </p>

      <h2>Responsabilidad</h2>
      <p>
        El titular no se hace responsable de interrupciones del servicio, errores técnicos o
        del uso que terceros hagan de la información publicada. Los resultados de los procesos
        de transformación personal dependen del compromiso y las circunstancias de cada
        persona y no se garantizan.
      </p>

      <h2>Enlaces</h2>
      <p>
        Este sitio contiene enlaces a plataformas de terceros (Hotmart, Calendly, WhatsApp,
        Instagram, YouTube, TikTok, Skool…). El titular no se responsabiliza de sus
        contenidos ni de sus políticas.
      </p>

      <h2>Ley aplicable y jurisdicción</h2>
      <p>
        Se rige por la legislación española. Para cualquier controversia, las partes se
        someten a los juzgados y tribunales que correspondan conforme a la normativa de
        consumidores y usuarios.
      </p>
    </LegalLayout>
  );
}
